import { render, staticRenderFns } from "./DataImplementationInfo.vue?vue&type=template&id=596c5e9e&scoped=true&"
import script from "./DataImplementationInfo.vue?vue&type=script&lang=js&"
export * from "./DataImplementationInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataImplementationInfo.vue?vue&type=style&index=0&id=596c5e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c5e9e",
  null
  
)

export default component.exports